// PnLBadge — Green/red P&L display (Angel One light theme)
import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

export default function PnLBadge({ value, size = 'md', showSign = true, showIcon = true }) {
  const num = parseFloat(value) || 0;
  const isProfit = num >= 0;
  const isZero = num === 0;

  const sizes = {
    sm: 'text-[11px]',
    md: 'text-xs',
    lg: 'text-xl font-bold',
  };

  if (isZero) {
    return <span className={`${sizes[size]} text-gray-500 font-mono`}>₹0.00</span>;
  }

  return (
    <span className={`inline-flex items-center gap-0.5 ${sizes[size]} font-mono font-semibold ${
      isProfit ? 'text-green-600' : 'text-red-500'
    }`}>
      {showIcon && (
        isProfit
          ? <FaArrowUp className="text-[7px]" />
          : <FaArrowDown className="text-[7px]" />
      )}
      {showSign && (isProfit ? '+' : '')}
      ₹{Math.abs(num).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
    </span>
  );
}
